// extracted by mini-css-extract-plugin
export default {"tabs":"MXPlHuN9wT","icon":"_4+WeT7IfeC","divider":"qoXvg-UDJC"};
    if(module.hot) {
      // 1653462682450
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  